import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src", "alt", "title"]
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "card-text card-details"
}
const _hoisted_5 = {
  key: 0,
  class: "promo bg-secondary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["h-100", ['card', 'card-' + _ctx.type]])
  }, [
    _createElementVNode("img", {
      src: _ctx.img || '/static/img/coming-soon.jpg',
      alt: _ctx.name,
      title: _ctx.name,
      class: "card-img-top"
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: _ctx.url,
        class: "card-title stretched-link"
      }, _toDisplayString(_ctx.name), 9, _hoisted_3),
      (_ctx.details.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details, (d) => {
              return (_openBlock(), _createElementBlock("div", {
                key: d.name
              }, [
                _createElementVNode("b", null, _toDisplayString(d.name) + ":", 1),
                _createTextVNode(" " + _toDisplayString(d.value), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.promo)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "PROMO"))
      : _createCommentVNode("", true)
  ], 2))
}